import { render, staticRenderFns } from "./wx-model-picker.mpx?vue&type=template&id=3604dcdb&isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex"
import script from "./wx-model-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex"
export * from "./wx-model-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex"
import style0 from "./wx-model-picker.mpx?vue&type=style&index=0&id=3604dcdb&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_22fefc60%22%7D&isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports